import { atom } from "jotai";
import { DataDumpAggregate } from "./MeritTier0HourlyTableChart/types";
import { useLocation } from "react-router";
import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import { useWorkScheduleIdOnCurrentPage } from "utils/customHooks/genericHooks";

export function useProcessIdOnTier0Page() {
  const { search } = useLocation();
  const processNameFromUrl = new URLSearchParams(search).get("process");
  const [workSchedules] = useWorkScheduleConfigJsonListAtom();
  const workScheduleId = useWorkScheduleIdOnCurrentPage();
  const workSchedule = workSchedules?.find(ws => ws.id === workScheduleId);
  const taps = workSchedule?.processes?.map(p => p.taps[0]);
  const processId = taps?.find(
    t => t.name === processNameFromUrl
  )?.machemetryId;
  return processId;
}
type ProcessIdsMap = {
  [workScheduleName: string]: {
    [processKey: string]: string;
  };
};
export function useProcessIdsMapOnTier0Page(): ProcessIdsMap {
  const [workSchedules] = useWorkScheduleConfigJsonListAtom();
  const groupsToIdsMap = Object.entries(workSchedules)?.reduce<ProcessIdsMap>(
    (acc, [_wsId, ws]) => {
      const wsName = ws.name;

      const processIdsToNamesMap: {
        [processKey: string]: string;
      } = ws.processes.reduce((acc, p) => {
        return { ...acc, [p.taps[0].machemetryId]: p.taps[0].name };
      }, {});

      return {
        ...acc,
        [wsName]: { ...acc[wsName], ...processIdsToNamesMap },
      };
    },
    {}
  );

  return groupsToIdsMap;
}

export const prevShiftDDAAtom = atom<DataDumpAggregate | null>(null);
